import { useCallback, useRef } from 'react';
/** Keeps container observation on the owned root without exposing its DOM node. */
export function useComposerContainerSize() {
    const containerRef = useRef(null);
    const observerRef = useRef(null);
    const subscriptionsRef = useRef(new Set());
    const setContainer = useCallback((container) => {
        containerRef.current = container;
        if (container !== null)
            return;
        observerRef.current?.disconnect();
        observerRef.current = null;
        subscriptionsRef.current.clear();
    }, []);
    const observeContainerSize = useCallback((listener) => {
        const container = containerRef.current;
        if (container === null)
            return () => { };
        const { width: widthPx, height: heightPx } = container.getBoundingClientRect();
        const subscription = { listener, widthPx, heightPx };
        const subscriptions = subscriptionsRef.current;
        subscriptions.add(subscription);
        if (observerRef.current === null) {
            observerRef.current = new ResizeObserver(() => {
                const currentContainer = containerRef.current;
                if (currentContainer === null)
                    return;
                const size = currentContainer.getBoundingClientRect();
                for (const subscriber of subscriptions) {
                    if (subscriber.widthPx === size.width && subscriber.heightPx === size.height)
                        continue;
                    subscriber.widthPx = size.width;
                    subscriber.heightPx = size.height;
                    subscriber.listener({ widthPx: size.width, heightPx: size.height });
                }
            });
            observerRef.current.observe(container, { box: 'border-box' });
        }
        listener({ widthPx, heightPx });
        return () => {
            subscriptions.delete(subscription);
            if (subscriptions.size > 0)
                return;
            observerRef.current?.disconnect();
            observerRef.current = null;
        };
    }, []);
    return { setContainer, observeContainerSize };
}
//# sourceMappingURL=useComposerContainerSize.js.map